import { InvoiceRequestPlatform } from './interfaces/api';

// The orders grid and the billing-request collector name platforms
// differently. Both the write side (creating a request for an order) and the
// read side (matching a request back to an order) translate through this one
// table — keeping them apart would let a record be written under a platform
// the lookup no longer recognizes.
export const COLLECTOR_PLATFORMS: Record<
    'lazada' | 'shopee' | 'tiktok',
    InvoiceRequestPlatform
> = {
    lazada: 'lazada',
    shopee: 'shopee',
    tiktok: 'tiktokshop',
};

// Collector platforms that name no marketplace — manual entry and the public
// web form — so they may match an order on any platform.
export const PLATFORM_AGNOSTIC: readonly InvoiceRequestPlatform[] = [
    'other',
    'web',
];
